<template>
  <div class="social-session stack tight">
    <UiPanel tone="social">
      <div class="header">
        <div>
          <h3 class="title">Social</h3>
          <div class="subtitle text-muted">Opinions and area reputation.</div>
        </div>

        <UiChip v-if="focusNpcStateId" variant="accent">Focused</UiChip>
      </div>
    </UiPanel>

    <SocialPanel
      :token="token"
      :characterId="characterId"
      :currentLocationId="currentLocationId"
      :locations="locations"
      :focusNpcStateId="focusNpcStateId"
      :onlyNpcStateId="onlyNpcStateId"
      @location-changed="emit('location-changed')"
    />
  </div>
</template>

<script setup lang="ts">
import SocialPanel from "../../../components/economy/SocialPanel.vue";
import UiChip from "../../../components/ui/UiChip.vue";
import UiPanel from "../../../components/ui/UiPanel.vue";

defineProps<{
  token: string;
  characterId: string;
  currentLocationId: string | null;
  locations: Array<{ id: string; name: string }>;
  focusNpcStateId?: string | null;
  onlyNpcStateId?: string | null;
}>();

const emit = defineEmits<{
  (e: "location-changed"): void;
}>();
</script>

<style scoped>
.social-session {
  min-width: 0;
}

.header {
  display: flex;
  justify-content: space-between;
  gap: var(--space-md);
  align-items: flex-start;
}

.title {
  margin: 0;
  font-family: var(--font-display);
  letter-spacing: 0.02em;
}

.subtitle {
  font-size: 0.9rem;
  margin-top: 0.15rem;
}
</style>
